import './AssignmentsPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import update from 'immutability-helper';
import ReduxInfiniteScroll from 'redux-infinite-scroll';
import classNames from 'classnames';

import AssignmentContentsReviewModal from './modals/AssignmentContentsReviewModal';
import AssignmentContentsSelectionModal from './modals/AssignmentContentsSelectionModal';
import AssignmentDetailsModal from './modals/AssignmentDetailsModal';
import AssignmentEditModal from './modals/AssignmentEditModal';
import AssignmentEditAdvancedModal from './modals/AssignmentEditAdvancedModal';
import AssignmentPinpointsReviewModal from './modals/AssignmentPinpointsReviewModal';
import AssignmentPinpointsSelectionModal from './modals/AssignmentPinpointsSelectionModal';
import AssignmentUsersReviewModal from './modals/AssignmentUsersReviewModal';
import AssignmentUsersSelectionModal from './modals/AssignmentUsersSelectionModal';
import Card from 'components/Card';
import Content from 'components/Content';
import ContentHeader from 'components/ContentHeader';
import ContentOptions from 'components/ContentOptions';
import ContentOptionsMenu from 'components/ContentOptionsMenu';
import CreateMenu from 'components/CreateMenu';
import LoadingSpinner from 'components/LoadingSpinner';
import ModalConfirm from 'components/ModalConfirm';
import Search from 'components/Search';

import { archiveUnarchiveAssignment, clearAssignment, cloneAssignment, deleteAssignment, emptyAssignments, getAssignments, getUsersAndSetAssignment, postPutAssignment, setAssignment, updateAssignments, updateSearchTerm } from './store/actions';
import { closeConfirmModal, closeModal, openConfirmModal, openModal, updateTitle } from 'containers/App/store/actions';
import { emptyContent, getContent } from 'containers/ContentPage/store/actions';
import { emptyUsers, getUsers } from 'containers/UsersPage/store/users/actions';
import { emptyPinpoints, getPinpoints } from 'containers/PinpointsPage/store/actions';

import { FILTER_BY_OPTIONS, SORT_BY_OPTIONS } from './constants';
import { MODALS } from 'utils/constants';

import { stopAssignmentOrRemoveAssignment } from './utils';

class AssignmentsPage extends React.Component {
    constructor() {
        super();

        this.createMenuLinks = [
            {
                icon: 'assignments',
                mobileLinkUrlString: '/assignments',
                onClick: this._openAssignmentModal.bind(this, null, MODALS.ASSIGNMENT_EDIT),
                text: 'Assignment'
            }
        ];

        this.oldAssignment = {};

        this.removeItem = {};
        this.removeType = '';
    }
    componentWillMount() {
        if(this.props.routing.locationBeforeTransitions.pathname.indexOf('/new') !== -1) {
            let newAssignmentObj = update(this.props.assignments.assignment, {});
            this.props.emptyAssignments();
            this.props.setAssignment(newAssignmentObj);
            this.props.changeLocation('/assignments');
            this._openAssignmentModal(null, MODALS.ASSIGNMENT_EDIT);
        } else {
            this.props.emptyAssignments();
        }
        this.props.updateTitle('Assignments');
    }

    _loadAssignments() {
        if(this.props.assignments.isFetching === false) {
            this.props.getAssignments();
        }
    }

    _cancelDelete() {
        this.props.closeConfirmModal();
        if(this.props.app.modal === '') {
            this.props.clearAssignment();
        }
    }

    _confirmDelete(assignment) {
        this.props.setAssignment(assignment);
        this.props.openConfirmModal(MODALS.ASSIGNMENT_DELETE_CONFIRM);
    }

    _confirmRemoveItem(item, type) {
        this.removeItem = item;
        this.removeType = type;
        console.log(item, type);
        this.props.openConfirmModal(MODALS.ASSIGNMENT_CONTENT_REMOVE_CONFIRM);
    }

    _cancelCloneAssignment() {
        this.props.closeConfirmModal();
        this.props.clearAssignment();
    }

    _confirmCloneAssignment(assignment, event) {
        event.stopPropagation();
        this.props.setAssignment(assignment);
        this.props.openConfirmModal(MODALS.ASSIGNMENT_CLONE_CONFIRM);
    }

    _handleCloneAssignment() {
        let newAssignmentObj = JSON.parse(JSON.stringify(this.props.assignments.assignment));

        this.props.cloneAssignment(newAssignmentObj, () => {
            this.props.closeConfirmModal();
        });
    }

    _handleDeleteAssignment() {
        this.props.deleteAssignment(() => {
            this.props.closeConfirmModal();
            this.props.closeModal();
        });
    }

    _confirmToggleArchiveAssignment(assignment) {
        this.props.setAssignment(assignment);
        this.props.openConfirmModal(MODALS.ASSIGNMENT_ARCHIVE_CONFIRM);
    }

    _cancelArchiveAssignment() {
        this.props.closeConfirmModal();
        this.props.clearAssignment();
    }

    _handleArchiveAssignment() {
        this.props.archiveUnarchiveAssignment()
            .then(() => {
                this.props.closeConfirmModal();
            });
    }

    /**
     * @desc    Dispatches actions necessary to filter and GET assignments
     * @param   filterBy
     */
    _handleFilter(filterBy) {
        let newAssignmentsObj = update(this.props.assignments, {
            pageNumber: {$set: 0},
            filterBy: {$set: filterBy},
            searchTerm: {$set: ''},
            hasMore: {$set: true},
            allAssignments: {$set: []}
        });
        if(newAssignmentsObj.sortBy === 'status') {
            newAssignmentsObj.sortBy = 'modified';
        }
        this.props.updateAssignments(newAssignmentsObj);
        this.props.getAssignments();
    }

    _handleModalClose() {
        this.props.closeModal();
        this.props.clearAssignment();
        this.oldAssignment= {};
        this.props.emptyContent();
        this.props.emptyPinpoints();
        this.props.emptyUsers();
    }

    _handleRemoveItem() {
        let newAssignmentObj = update(this.props.assignments.assignment, {});
        let foundItemIndex = -1;
        for(var i = 0, l = newAssignmentObj[this.removeType].length; i < l; i++) {
            if(newAssignmentObj[this.removeType][i].id === this.removeItem.id) {
                foundItemIndex = i;
                break;
            }
        }
        if(foundItemIndex !== -1) {
            newAssignmentObj[this.removeType].splice(foundItemIndex, 1);
        }
        this.props.setAssignment(newAssignmentObj);
        this.removeItem = {};
        this.removeType = '';
    }

    _handleSaveAssignment() {
        let itemExists = this.props.assignments.assignment.id != null;
        this.props.postPutAssignment(() => {
            if(itemExists === true) {
                this.props.openModal(MODALS.ASSIGNMENT_DETAILS);
            } else {
                this.props.clearAssignment();
                this.props.closeModal();
            }
        });
    }

    _handleSearch() {
        let newAssignmentsObj = update(this.props.assignments, {
            pageNumber: {$set: 0},
            hasMore: {$set: true},
            allAssignments: {$set: []}
        });
        this.props.updateAssignments(newAssignmentsObj);
        this.props.getAssignments();
    }

    _handleSelection(newObj, type) {
        let newAssignmentObj = update(this.props.assignments.assignment, {});
        newAssignmentObj[type] = newObj;
        this.props.setAssignment(newAssignmentObj);
    }

    /**
     * @desc    Dispatches actions necessary to sort and GET assignments
     * @param   sortBy
     * @param   sortDirection
     */
    _handleSort(sortBy, sortDirection) {
        if(sortBy !== this.props.assignments.sortBy || sortDirection !== this.props.assignments.sortDirection) {
            let newAssignmentsObj = update(this.props.assignments, {
                pageNumber: {$set: 0},
                sortBy: {$set: sortBy},
                sortDirection: {$set: sortDirection},
                searchTerm: {$set: ''},
                hasMore: {$set: true},
                allAssignments: {$set: []}
            });
            this.props.updateAssignments(newAssignmentsObj);
            this.props.getAssignments();
        }
    }

    _closeReviewModal(shouldReset, type) {
        if(shouldReset === true) {
            let newAssignmentObj = update(this.props.assignments.assignment, {});
            newAssignmentObj[type] = JSON.parse(JSON.stringify(this.oldAssignment[type]));
            this.props.setAssignment(newAssignmentObj);
        }
        this.props.openModal(MODALS.ASSIGNMENT_EDIT);
    }

    _closeAssignmentEditModal() {
        if(this.props.assignments.assignment.id != null) {
            this.props.setAssignment(this.oldAssignment);
            this.props.openModal(MODALS.ASSIGNMENT_DETAILS);
        } else {
            this.props.clearAssignment();
            this.props.closeModal();
            this.oldAssignment = {};
        }
    }

    _openAssignmentModal(assignment, modal) {
        if(assignment != null) {
            this.props.getUsersAndSetAssignment(assignment);
        } else {
            assignment = this.props.assignments.assignment;
        }
        this.oldAssignment = JSON.parse(JSON.stringify(assignment));
        this.props.openModal(modal);
    }

    _openSelectionModal(type) {
        if(type === 'contents') {
            this.props.openModal(MODALS.ASSIGNMENT_CONTENT_SELECTION);
        } else if(type === 'users') {
            this.props.openModal(MODALS.ASSIGNMENT_USERS_SELECTION);
        } else if(type === 'beacons') {
            this.props.openModal(MODALS.ASSIGNMENT_PINPOINTS_SELECTION)
        }
    }

    _goBackToReviewModal(modal) {
        this.props.emptyContent();
        this.props.emptyUsers();
        this.props.emptyPinpoints();

        this.props.openModal(modal);
    }

    _selectionModalLoadMore(type) {
        if(type === 'contents') {
            if(this.props.content.isFetching === false) {
                this.props.getContent();
            }
        } else if(type === 'users') {
            if(this.props.users.isFetching === false) {
                this.props.getUsers();
            }
            this.props.getUsers();
        } else if(type === 'beacons') {
            if(this.props.pinpoints.isFetching === false) {
                this.props.getPinpoints();
            }
        }
    }

    render() {
        let { assignments, closeConfirmModal, openModal, setAssignment } = this.props;

        return (
            <Content>
                <ContentHeader>
                    <Search handleSearchTermChange={this.props.updateSearchTerm}
                            handleSearch={this._handleSearch.bind(this)}
                            value={assignments.searchTerm} />
                    <ContentOptions>
                        <ContentOptionsMenu icon="sort"
                                            disabled={assignments.searchTerm !== ''}>
                            {SORT_BY_OPTIONS.map((option) => {
                                return (
                                    <div role="button"
                                         className={classNames({'active': assignments.searchTerm === '' && option.sortBy === assignments.sortBy && option.sortDirection === assignments.sortDirection})}
                                         onClick={this._handleSort.bind(this, option.sortBy, option.sortDirection)}
                                         key={option.key}>
                                        {option.text}
                                    </div>
                                )
                            })}
                        </ContentOptionsMenu>
                        <ContentOptionsMenu icon="filter"
                                            disabled={assignments.searchTerm !== ''}>
                            {FILTER_BY_OPTIONS.map((option) => {
                                return (
                                    <div role="button"
                                         className={classNames({'active': assignments.searchTerm === '' && option.filterBy === assignments.filterBy})}
                                         onClick={() => {
                                             if(assignments.searchTerm !== '' || option.filterBy !== assignments.filterBy) {
                                                 this._handleFilter(option.filterBy)
                                             }
                                         }}
                                         key={option.key}>
                                        {option.text}
                                    </div>
                                )
                            })}
                        </ContentOptionsMenu>
                    </ContentOptions>
                </ContentHeader>
                <ReduxInfiniteScroll elementIsScrollable={false}
                                     hasMore={assignments.hasMore}
                                     loadMore={this._loadAssignments.bind(this)}
                                     loadingMore={assignments.isFetching === true}
                                     className="cards"
                                     loader={<LoadingSpinner />}>
                    {assignments.allAssignments.map((assignment) => {
                        return <Card item={assignment}
                                     cloneAssignment={this._confirmCloneAssignment.bind(this, assignment)}
                                     key={assignment.id}
                                     handleDelete={this._confirmDelete.bind(this, assignment)}
                                     onClick={this._openAssignmentModal.bind(this, assignment, MODALS.ASSIGNMENT_DETAILS)}
                                     openEditModal={this._openAssignmentModal.bind(this, assignment, MODALS.ASSIGNMENT_EDIT)}
                                     toggleArchiveAssignment={this._confirmToggleArchiveAssignment.bind(this, assignment)}
                                />
                    })}
                    <div className="card empty"></div>
                    <div className="card empty"></div>
                    <div className="card empty"></div>
                    {assignments.hasMore === false ? (
                            <div className="cards__no-more">
                                No more Assignments to load.
                            </div>
                        ) : null}
                </ReduxInfiniteScroll>

                <CreateMenu links={this.createMenuLinks} />

                <AssignmentDetailsModal closeModal={this._handleModalClose.bind(this)}
                                        deleteAssignment={this._confirmDelete.bind(this)}
                                        isSaving={assignments.isSaving}
                                        openEditModal={this._openAssignmentModal.bind(this)}
                                        openModal={openModal.bind(this)}
                                        assignment={assignments.assignment}
                                        show={this.props.app.modal === MODALS.ASSIGNMENT_DETAILS} />

                <AssignmentContentsReviewModal closeModal={this._handleModalClose.bind(this)}
                                               modalThatIsOpen={this.props.app.modal}
                                               removeContentPiece={this._confirmRemoveItem.bind(this)}
                                               reviewConfirm={this._closeReviewModal.bind(this, false, 'contents')}
                                               reviewCancel={this._closeReviewModal.bind(this, true, 'contents')}
                                               openModal={openModal.bind(this)}
                                               openSelectionModal={this._openSelectionModal.bind(this, 'contents')}
                                               setAssignment={setAssignment.bind(this)}
                                               show={this.props.app.modal === MODALS.ASSIGNMENT_CONTENT_LIST || this.props.app.modal === MODALS.ASSIGNMENT_CONTENT_REVIEW}
                                               assignment={assignments.assignment} />

                <AssignmentContentsSelectionModal closeModal={this._handleModalClose.bind(this)}
                                                  content={this.props.content}
                                                  loadMore={this._selectionModalLoadMore.bind(this, 'contents')}
                                                  handleChange={this._handleSelection.bind(this)}
                                                  openReviewModal={this._goBackToReviewModal.bind(this, MODALS.ASSIGNMENT_CONTENT_REVIEW)}
                                                  show={this.props.app.modal === MODALS.ASSIGNMENT_CONTENT_SELECTION}
                                                  assignment={assignments.assignment} />

                <AssignmentUsersReviewModal closeModal={this._handleModalClose.bind(this)}
                                            modalThatIsOpen={this.props.app.modal}
                                            openModal={openModal.bind(this)}
                                            openSelectionModal={this._openSelectionModal.bind(this, 'users')}
                                            removeUser={this._confirmRemoveItem.bind(this)}
                                            reviewConfirm={this._closeReviewModal.bind(this, false, 'users')}
                                            reviewCancel={this._closeReviewModal.bind(this, true, 'users')}
                                            show={this.props.app.modal === MODALS.ASSIGNMENT_USERS_LIST || this.props.app.modal === MODALS.ASSIGNMENT_USERS_REVIEW}
                                            assignment={assignments.assignment} />

                <AssignmentUsersSelectionModal closeModal={this._handleModalClose.bind(this)}
                                               users={this.props.users}
                                               handleChange={this._handleSelection.bind(this)}
                                               loadMore={this._selectionModalLoadMore.bind(this, 'users')}
                                               openReviewModal={this._goBackToReviewModal.bind(this, MODALS.ASSIGNMENT_USERS_REVIEW)}
                                               show={this.props.app.modal === MODALS.ASSIGNMENT_USERS_SELECTION}
                                               assignment={assignments.assignment} />

                <AssignmentPinpointsReviewModal closeModal={this._handleModalClose.bind(this)}
                                                modalThatIsOpen={this.props.app.modal}
                                                openSelectionModal={this._openSelectionModal.bind(this, 'beacons')}
                                                openModal={openModal.bind(this)}
                                                removePinpoint={this._confirmRemoveItem.bind(this)}
                                                reviewCancel={this._closeReviewModal.bind(this, true, 'beacons')}
                                                reviewConfirm={this._closeReviewModal.bind(this, false, 'beacons')}
                                                show={this.props.app.modal === MODALS.ASSIGNMENT_PINPOINTS_LIST || this.props.app.modal === MODALS.ASSIGNMENT_PINPOINTS_REVIEW}
                                                assignment={assignments.assignment} />

                <AssignmentPinpointsSelectionModal closeModal={this._handleModalClose.bind(this)}
                                                   pinpoints={this.props.pinpoints}
                                                   handleChange={this._handleSelection.bind(this)}
                                                   loadMore={this._selectionModalLoadMore.bind(this, 'beacons')}
                                                   openReviewModal={this._goBackToReviewModal.bind(this, MODALS.ASSIGNMENT_PINPOINTS_REVIEW)}
                                                   show={this.props.app.modal === MODALS.ASSIGNMENT_PINPOINTS_SELECTION}
                                                   assignment={assignments.assignment} />

                <AssignmentEditModal assignment={assignments.assignment}
                                     closeModal={this._handleModalClose.bind(this)}
                                     cancelModal={this._closeAssignmentEditModal.bind(this)}
                                     existingAssignmentState={this.oldAssignment.state}
                                     isSaving={assignments.isSaving}
                                     openModal={openModal.bind(this)}
                                     saveAssignment={this._handleSaveAssignment.bind(this)}
                                     setAssignment={setAssignment.bind(this)}
                                     show={this.props.app.modal === MODALS.ASSIGNMENT_EDIT}/>

                <AssignmentEditAdvancedModal assignment={assignments.assignment}
                                             closeModal={this._handleModalClose.bind(this)}
                                             isSaving={assignments.isSaving}
                                             openModal={openModal.bind(this)}
                                             setAssignment={setAssignment.bind(this)}
                                             show={this.props.app.modal === MODALS.ASSIGNMENT_EDIT_ADVANCED}/>

                {/*Modal for confirming delete content*/}
                <ModalConfirm show={this.props.app.modalConfirm === MODALS.ASSIGNMENT_DELETE_CONFIRM}
                              cancelAction={this._cancelDelete.bind(this)}
                              confirmAction={this._handleDeleteAssignment.bind(this)}
                              confirmText={stopAssignmentOrRemoveAssignment(assignments.assignment.state, assignments.assignment.status) === true ? 'Stop' : 'Remove'}
                              disabled={assignments.isSaving}
                              text={stopAssignmentOrRemoveAssignment(assignments.assignment.state, assignments.assignment.status) === true ? 'Stopping this assignment will cancel it and remove it from your users\' Inbox. All status records will be kept.' : 'This action will permanently remove your assignment from the list.'}
                              title={stopAssignmentOrRemoveAssignment(assignments.assignment.state, assignments.assignment.status) === true ? 'Stop?' : 'Remove?'} />

                {/*Modal for confirming removal of group from user*/}
                <ModalConfirm show={this.props.app.modalConfirm === MODALS.ASSIGNMENT_CONTENT_REMOVE_CONFIRM}
                              cancelAction={closeConfirmModal.bind(this)}
                              confirmAction={() => {
                                  this._handleRemoveItem();
                                  this.props.closeConfirmModal();
                              }}
                              disabled={assignments.isSaving}
                              text={`Are you sure you want to remove this?`} />

                {/*Modal for confirming clone assignment*/}
                <ModalConfirm show={this.props.app.modalConfirm === MODALS.ASSIGNMENT_CLONE_CONFIRM}
                              cancelAction={this._cancelCloneAssignment.bind(this)}
                              confirmAction={this._handleCloneAssignment.bind(this)}
                              disabled={assignments.isSaving}
                              text="Are you sure you want to clone this assignment?"
                              title={this.props.assignments.assignment.name} />

                {/*Modal for confirming clone assignment*/}
                <ModalConfirm show={this.props.app.modalConfirm === MODALS.ASSIGNMENT_ARCHIVE_CONFIRM}
                              cancelAction={this._cancelArchiveAssignment.bind(this)}
                              confirmAction={this._handleArchiveAssignment.bind(this)}
                              disabled={assignments.isSaving}
                              text={`Are you sure you want to ${assignments.assignment.archived === true ? 'un' : ''}archive this assignment?`}
                              title={this.props.assignments.assignment.name} />
            </Content>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.app,
        assignments: state.assignments,
        content: state.content,
        pinpoints: state.pinpoints,
        routing: state.routing,
        users: state.users
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        archiveUnarchiveAssignment: () => dispatch(archiveUnarchiveAssignment()),
        changeLocation: (locationString) => dispatch(routerActions.push(locationString)),
        clearAssignment: () => dispatch(clearAssignment()),
        cloneAssignment: (assignmentObj, callback) => dispatch(cloneAssignment(assignmentObj, callback)),
        closeConfirmModal: () => dispatch(closeConfirmModal()),
        closeModal: () => dispatch(closeModal()),
        deleteAssignment: (callback) => dispatch(deleteAssignment(callback)),
        emptyAssignments: () => dispatch(emptyAssignments()),
        emptyContent: () => dispatch(emptyContent()),
        emptyPinpoints: () => dispatch(emptyPinpoints()),
        emptyUsers: () => dispatch(emptyUsers()),
        getAssignments: (callback) => dispatch(getAssignments(callback)),
        getContent: () => dispatch(getContent()),
        getPinpoints: () => dispatch(getPinpoints()),
        getUsers: () => dispatch(getUsers()),
        getUsersAndSetAssignment: (assignmentObj) => dispatch(getUsersAndSetAssignment(assignmentObj)),
        openConfirmModal: (modalNameString) => dispatch(openConfirmModal(modalNameString)),
        openModal: (modalNameString) => dispatch(openModal(modalNameString)),
        postPutAssignment: (callback) => dispatch(postPutAssignment(callback)),
        setAssignment: (assignmentObj) => dispatch(setAssignment(assignmentObj)),
        updateAssignments: (assignmentsObj) => dispatch(updateAssignments(assignmentsObj)),
        updateSearchTerm: (searchTerm) => dispatch(updateSearchTerm(searchTerm)),
        updateTitle: (title) => dispatch(updateTitle(title))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentsPage);



// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/index.js